import * as React from 'react'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

type Props = {
  title: string
  description: string
  listOfZips: number[]
  listOfMinorCities: string[]
}

export const CityNearYouSection: React.FC<Props> = ({ title, description, listOfMinorCities, listOfZips }) => {
  if (listOfZips && listOfMinorCities) {
    return (
      <GraySection className="text-center">
        <Container>
          <div>
            <h3 className="title">{title}</h3>
            <p className="description">{description}</p>
            <p style={{ color: '#818b92' }}>{listOfMinorCities.join(', ')}</p>
            <div style={{ marginBottom: 30, marginTop: 30 }} />
          </div>
        </Container>
      </GraySection>
    )
  }
  return null
}
